import React, { useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import { Form, Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";
import "./ShowSecretDialog.css";

const ShowSecretsDialog = ({
  show,
  onHide,
  title,
  hint,
  secretLabel,
  secret,
  showCopy = true,
  info,
}) => {
  const inputRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret ?? "");
    } catch {
      // fallback
      if (inputRef.current) {
        inputRef.current.select();
        document.execCommand("copy");
      }
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <BaseDialog
      show={show}
      onHide={onHide}
      noFooter
      title={<div>{title}</div>}
      body={
        <div>
          <Form.Group className="mb-3">
            {hint && <p>{hint}</p>}
            <Form.Label>{secretLabel}</Form.Label>

            <div className="copyable-input">
              <Form.Control
                readOnly
                ref={inputRef}
                value={secret ?? ""}
                className="secret-font"
              />
              {showCopy && (
                <Button
                  type="button"
                  size="sm"
                  variant="outline-secondary"
                  className="copy-btn"
                  onClick={copy}
                  aria-label="Copy to clipboard"
                >
                  <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
                </Button>
              )}
            </div>
            <div className="mt-4">
              {info.map((i) => (
                <Row className="mb-1">
                  <Col sm={2} className="fw-bold">
                    <b>{i.label}</b>
                  </Col>
                  <Col sm={8}>{i.value}</Col>
                </Row>
              ))}
            </div>
          </Form.Group>
        </div>
      }
    />
  );
};

export default withTranslation()(ShowSecretsDialog);
